/**
 * What a create form (upload, new folder) shows when the classification
 * policy could not be read (review LB6T7-BF-01). The form does not submit
 * then: without the answer it cannot know whether this tenant's frameworks
 * show the classification controls, and submitting without them would store
 * the item unclassified. The same alert-with-retry line the folder pickers
 * use (folder-picker-states.tsx).
 */
import { Button } from '@/components/ui/button';

export const CLASSIFICATION_POLICY_ERROR_TEXT =
  'The classification settings could not be loaded, so this cannot be saved yet.';

export function ClassificationPolicyError({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center gap-x-2 text-xs text-destructive"
      data-testid="classification-policy-error"
    >
      <span>{CLASSIFICATION_POLICY_ERROR_TEXT}</span>
      <Button
        type="button"
        variant="link"
        className="h-auto p-0 text-xs"
        onClick={() => onRetry()}
        title="Load the classification settings again"
      >
        Retry
      </Button>
    </div>
  );
}
